import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

const Link = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  target,
  ...other
}) => {
  const internal = to && to.startsWith('/')
  const hash = to && to.includes('#')
  const query = to && to.includes('?')
  const newTab = target === '_blank'

  if (internal && !hash && !query && !newTab) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a href={to} target={target} {...other}>
      {children}
    </a>
  )
}

export default Link
